import { render, staticRenderFns } from "./LocationBreadcrumb.vue?vue&type=template&id=2192dd7c&scoped=true&"
import script from "./LocationBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./LocationBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./LocationBreadcrumb.vue?vue&type=style&index=0&id=2192dd7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2192dd7c",
  null
  
)

export default component.exports